
import React, { useState, useEffect } from 'react';



//import logo from './image/Glogo.png';
//import login from './login.png';
import { Link } from "react-router-dom";
import '../App.css';


import 'bootstrap-icons/font/bootstrap-icons.css';

 //import { useEffect, useState } from 'react';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}


const Navbar = ({ darkMode, setDarkMode }) => {
  
  const isMobile = useIsMobile(); 
  //console.log(isMobile);
const [activeLink, setActiveLink] = useState('');
  return (

    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm fixed-top px-4 ">

      <div className="container-fluid">

        <Link className="navbar-brand fw-bold" to="/">
        <img src='/image/Glogo.png' alt="Logo" style={{height:"40px", marginRight:"10px" }} />
             Grey Imports
         </Link>
         {/* Hamburger (toggles offcanvas) */}
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
    >
      <span className="navbar-toggler-icon"></span>
    </button>
        
  
   {/* Offcanvas Sidebar */}
    <div
      className="offcanvas offcanvas-end text-bg-dark"
      tabIndex="-1"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title text-white" id="offcanvasNavbarLabel">Menu</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <ul className="navbar-nav justify-content-end flex-grow-1 gap-1 pe-3">
            <li className= "nav-item" data-bs-dismiss={activeLink ? 'offcanvas' : undefined} >
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
               <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'Home' ? 'active text-white' : ''} `} 
               href="#Home_Section" 
               onClick={() => setActiveLink('Home')}
               title='Home'><strong>
                Home</strong>
                </a>
               </div>

            </li>


  {/*
<li className="nav-item" data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
  <div className={`${!isMobile ? 'd-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`} style={{ maxWidth: '150px' }}>
    <a
      className={`nav-link text-truncate px-2 py-1 ${activeLink === 'Appointment' ? 'active text-white' : ''}`}
      href="#Appointment_Section"  // Link to a section within the same page
      onClick={() => setActiveLink('Appointment')}
      title="Appointment"
    >
      <strong>Appointment</strong>
    </a>
  </div>
</li>*/}




{/*<li className="nav-item" data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
  <div className={`${!isMobile ? 'd-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`} style={{ maxWidth: '150px' }}>
    <a
      className={`nav-link text-truncate px-2 py-1 ${activeLink === 'NewsPage' ? 'active text-white' : ''}`}
      href="#news-page"  // Link to a section within the same page
      onClick={() => setActiveLink('NewsPage')}
      title="NewsPage"
    >
      <strong>NewsPage</strong>
    </a>
  </div>
</li>*/}


            <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
               <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'latest' ? 'active text-white' : ''}`} 
               href="#NewReport" 
               onClick={() => setActiveLink('latest')}
               title='Latest Report'>
                <strong>Latest Report</strong></a></div>

            </li>
            <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-1 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
  <a
    className={`nav-link text-truncate px-2 py-1 ${activeLink === 'VIN' ? 'active text-white' : ''}`}
    href="#VerifyVIN"
    onClick={() => setActiveLink('VIN')}
    title="Verify U.ID with VIN"
  >
    <strong>Verify U.ID with VIN</strong>
  </a>
</div>

            </li>
            <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-1 border border-2 border-dark shadow' : 'border border-none '}`} style={{ maxWidth: '150px' }}>
               <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'TopSelling' ? 'active text-white' : ''}`} 
               href="#TopModel" 
               onClick={() => setActiveLink('TopSelling')}
               title="Top Selling MR">
               <strong> Top Selling MR</strong>
                </a>
</div>
            </li>
          






            <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-1 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
               <a className={`nav-link text-truncate px-2 py-1${activeLink === 'MR' ? 'active text-white' : ''}`} 
               href="#MREdata" 
               onClick={() => setActiveLink('MR')}
               title='Model Report'>
                <strong>Model Report</strong>
                </a>
</div>
            </li>
            <li className="nav-item  " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
<div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-1 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
               <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'SEV' ? 'active text-white' : ''}`} 
               href="#SEVExpiry" 
               onClick={() => setActiveLink('SEV')}
               title='Sevs Expiry Details'>
                <strong>Sevs Expiry Details</strong>
                </a>
</div>
            </li>

            
            <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
              <div className={`${!isMobile ?'d-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
              <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'Enquiry' ? 'active text-white' : ''}`} 
              href="#Enquiry_Section" 
              onClick={() => setActiveLink('Enquiry')}
              title='Enquiry'>
                <strong>Enquiry</strong>
                </a>
             </div>

            </li>





<li className="nav-item" data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
  <div className={`${!isMobile ? 'd-inline-block rounded overflow-hidden gap-2 border border-2 border-dark shadow' : 'border border-none '}`} style={{ maxWidth: '150px' }}>
    <Link
      to="/news-page"  // React Router Link to the separate page
      className={`nav-link text-truncate px-2 py-1 ${activeLink === 'NewsPage' ? 'active text-white' : ''}`}
      onClick={() => setActiveLink('NewsPage')}
      title="NewsPage"
    >
      <strong>NewsPage</strong>
    </Link>
  </div>
</li>

            
           <li className="nav-item " data-bs-dismiss={activeLink ? 'offcanvas' : undefined}>
            <div className={`${!isMobile ?' d-inline-block rounded overflow-hidden gap-1 border border-2 border-dark  shadow' : 'border border-none '}`}style={{ maxWidth: '150px' }}>
             <a className={`nav-link text-truncate px-2 py-1 ${activeLink === 'SignIN' ? 'active text-white' : ''}`}
              href="https://www.mdlreports.com.au/login" target="_blank" rel="noopener noreferrer" title='Sign In'>
              <img
                   src="/image/login.png"
                   alt="Login"
                   className="d-none d-md-inline me-2"
                   style={{ height: "20px",
                    filter: "invert(1) brightness(2)"

                    }}

                 /> 
  
                <span><strong>Sign In</strong></span>
             </a>
             </div>
           </li>
        </ul>
      
          
 
      
        </div>
        </div>
        </div>
        {/* 🌗 Dark Mode Toggle on the navbar */}
         {/* 🌙 Dark Mode Icon Toggle */}
        {/* 🌗 Dark Mode Toggle Button */}
        {/*<button
          className="btn btn-outline-secondary"
          onClick={() => setDarkMode(!darkMode)}
          title="Toggle dark mode"
        >
          <i className={`bi ${darkMode ? 'bi-sun-fill' : 'bi-moon-fill'}`}></i>
        </button>*/}
      

    </nav>

  );
  

};



export default Navbar;
